import { createSlice } from "@reduxjs/toolkit";

const partnersSlice = createSlice({
  name: "partners",
  initialState: {
    data: [],
    totalRecords: 0,
    currentPartner: null,
    partnerCompanies: [],
    partnerCompaniesTotal: 0,
    partnerUsers: [],
    partnerLogs: [],
    partnerLogsTotal: 0,
    isLoading: true,
    isLoadingLogs: false,
    isLoadingCompanies: false,
    error: null,
  },
  reducers: {
    setPartners(state, action) {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.total || 0;
      state.isLoading = false;
    },
    setCurrentPartner(state, action) {
      state.currentPartner = action.payload;
      state.isLoading = false;
    },
    setPartnerCompanies(state, action) {
      state.partnerCompanies = action.payload.rows;
      state.partnerCompaniesTotal = action.payload.total;
      state.isLoadingCompanies = false;
    },
    setCompaniesLoading(state, action) {
      state.isLoadingCompanies = action.payload;
    },
    setPartnerUsers(state, action) {
      state.partnerUsers = action.payload;
    },
    setPartnerLogs(state, action) {
      state.partnerLogs = action.payload.logs;
      state.partnerLogsTotal = action.payload.total;
      state.isLoadingLogs = false;
    },
    setLogsLoading(state, action) {
      state.isLoadingLogs = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
    resetPartner(state) {
      state.currentPartner = null;
      state.partnerCompanies = [];
      state.partnerCompaniesTotal = 0;
      state.partnerUsers = [];
      state.partnerLogs = [];
      state.partnerLogsTotal = 0;
    },
  },
});

export const { setPartners, setCurrentPartner, setPartnerCompanies, setCompaniesLoading, setPartnerUsers, setPartnerLogs, setLogsLoading, setLoading, setError, clearError, resetPartner } = partnersSlice.actions;
export default partnersSlice.reducer;
